import React, { memo } from "react";
import { useIntl } from "react-intl";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import { PasswordsDataFormView } from "../Form/ChangePasswordForm";
import { UserDataFormView } from "../Form/UserDataForm";

export const UserSettingsModal = memo(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const UserDataForm = UserDataFormView as any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const UserPasswordsForm = PasswordsDataFormView as any;
  const intl = useIntl();
  return (
    <Tabs
      defaultIndex={0}
      className="tabset tabset_dark"
      style={{
        width: "100%",
        marginRight: 0,
        float: "left",
      }}
      selectedTabClassName="tabset__item--selected"
    >
      <TabList className="profile__panel profile__panel_sub">
        <Tab className="tabset__item">
          {intl.formatMessage({
            id: "boilerplate.components.ModalRoom.MyData",
          })}
        </Tab>
        <Tab className="tabset__item">
          {intl.formatMessage({
            id: "boilerplate.components.ModalRoom.ChangePassword",
          })}
        </Tab>
      </TabList>
      <TabPanel>
        <UserDataForm />
      </TabPanel>
      <TabPanel>
        <UserPasswordsForm />
      </TabPanel>
    </Tabs>
  );
});

UserSettingsModal.displayName = "UserSettingsModal";
